import firebase from './firebase-client';

const db = firebase.firestore();
export default db;
